// export const api_url = "https://prathna-backend-gi1w.onrender.com"
export const api_url = "https://api.myprarthana.in"
